/**
 * Sube al tope al cambiar de lección o de pantalla del examen.
 *
 * **No alcanza con `window.scrollTo`.** Dentro del shell nuevo el que scrollea no
 * es la ventana sino el `<main class="overflow-y-auto">` que envuelve al
 * `<Outlet />`: `document.documentElement` no desborda, así que un
 * `window.scrollTo(0, 0)` no hace absolutamente nada y se entra a la lección
 * siguiente a la altura del resumen de la anterior. En mobile —donde la pantalla
 * monta bajo `DashboardLayout`— sí scrollea la ventana.
 *
 * Por eso sube el ancestro scrolleable que encuentre Y la ventana: cuál de los dos
 * corresponde depende del layout, y hacer los dos es más barato que preguntarlo.
 *
 * @param desde Un nodo de la pantalla, para arrancar a buscar el contenedor.
 */
export function scrollAlTope(desde: HTMLElement | null): void {
  const suave: ScrollToOptions = { top: 0, behavior: 'smooth' };

  for (let el = desde?.parentElement; el; el = el.parentElement) {
    const overflowY = getComputedStyle(el).overflowY;
    if (/auto|scroll/.test(overflowY) && el.scrollHeight > el.clientHeight) {
      el.scrollTo(suave);
      break;
    }
  }

  window.scrollTo(suave);
}
